import { authService } from '../services/auth.service'
export const auth = {
  namespaced: true,
  state: {
    locales: [
      {
        name: 'Español (Latinoamérica)',
        code: 'es'
      },
      {
        name: 'English (US)',
        code: 'en'
      },
      {
        name: 'Português (Brasil)',
        code: 'pt'
      }
    ],
    locale: 'pt',
    user: {},
    type: null,
    profileEdit: {},
    editorProfileDrawer: false
  },
  getters: {
    user: state => state.user
  },
  actions: {
    setData({commit }) {
      const type = localStorage.getItem('type_user')
      commit('setTypeUser', type)
    },
    login ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        authService.login(payload)
          .then(
            res => {
              resolve(res)
            },
            err => {
              console.log('reject')
              console.log(err)
              reject(err)
            }
          )
      })
    },
    getProfile ({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        authService.getUserData()
          .then(
            res => {
              commit('setUser', res.data)
              commit('changeLanguageUser', res.data.language_code)
              resolve(res)
            },
            err => {
              reject(err)
            }
          )
      })
    },
    getExternalProfile({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        authService.getExternalProfile(payload)
          .then(
            res => {
              commit('setUser', res.data)
              commit('changeLanguageUser', res.data.language_code)
            },
            err => {
              reject(err)
            }
          )
      })
    },
    updateExternalProfile ({ commit, state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        authService.updateExternalUser({id: payload.id, data: payload.data})
          .then(
            async res => {
              await dispatch('getExternalProfile', payload.id)
              if (state.locale !== payload.data.language_code) {
                commit('changeLanguageUser', payload.data.language_code)
              }
              resolve(res)
            },
            err => {
              reject(err)
            }
          )
      })
    },
    updateProfile ({ commit, state, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        authService.updateProfile(payload)
          .then(
            async res => {
              await dispatch('getProfile')
              if (state.locale !== payload.language_code) {
                commit('changeLanguageUser', payload.language_code)
              }
              resolve(res)
            },
            err => {
              reject(err)
            }
          )
      })
    },
    changePassword ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        authService.changePassword(payload)
          .then(
            res => {
              resolve(res)
            },
            err => {
              reject(err)
            }
          )
      })
    },
    getRoles () {
      return new Promise((resolve, reject) => {
        authService.getRoles()
          .then(
            res => {
              resolve(res)
            },
            err => {
              reject(err)
            }
          )
      })
    }
  },
  mutations: {
    setUser (vuexState, payload) {
      vuexState.user = payload
    },
    changeLanguageUser (vuexState, language) {
      if (vuexState.locales.find(({ code }) => code === language)) {
        vuexState.locale = language
        app.$i18n.locale = language
      }
    },
    resetLanguaje (vuexState) {
      vuexState.locale = 'en'
      app.$i18n.locale = 'en'
    },
    changeProfileEditor (vuexState, payload) {
      vuexState.profileEdit = payload
    },
    editorProfileDrawer (vuexState, payload) {
      vuexState.editorProfileDrawer = payload
    },
    setTypeUser (vuexState, payload) {
      vuexState.type = payload
    }
  }
}
